import api from '@pray/shared/utils/api';

import type { SeedProvider, SeedRunRecipientListEnvelope } from './types';

const RUNS_URL = '/web/studio/admin/seed-emails/runs';

export type GetRunRecipientsParams = {
  runId: string;
  q?: string;
  isp?: SeedProvider | '';
  limit?: number;
  offset?: number;
};

/**
 * Every seed a run reached, paged by the server.
 *
 * `stats` covers the whole run rather than the page, because the ISP control writes those counts
 * inside its own labels and the header line names the total.
 */
export async function getRunRecipients({ runId, q, isp, limit = 15, offset = 0 }: GetRunRecipientsParams) {
  const params: Record<string, string | number> = { limit, offset };
  if (q) params.q = q;
  if (isp) params.isp = isp;

  const res = await api.executeGetRequest<SeedRunRecipientListEnvelope>(`${RUNS_URL}/${runId}/recipients`, params);
  return res.data;
}
